<template>
  <div id="darshan">
	<v-app id="inspire">
		<v-container
			fluid
			style="min-height: 0;"
			grid-list-lg
			text-xs-center
		>
			<v-layout column>
				<v-flex xl12>
					<h3 style="text-align:center"><span style="color: rgba(0,0,0,1); font-weight:bold;"> <span>Current Darshan Token Number</span></span></h3>
					<div v-for="picture in getToken()" v-bind:key="picture.id" class="image-card">
					  <div class="image-card__picture" align='center'>
						<img :src="picture.url" />
					  </div>
					</div>
          <p style="text-align: justify">
						NOTE
					</p>
					<ol>
						<li style="text-align: justify"> This number is only for information, do not use for darshan entry.</li>
						<li style="text-align: justify">Your network must be working well and updating your app continuously for this function. Avatar Meher Baba Trust is not responsible for missing darshan due to bad network connection.</li>
					</ol>
					<p style="text-align: justify">
						ATTENTION
					</p>
					<ol>
						<li style="text-align: justify">Darshan of Beloved Avatar Meher Baba will be available inside the Tomb Shrine through a regulated queue designated specifically for this occasion.</li>
						<li style="text-align: justify">However, due to the influx of pilgrims during Amartithi, it is requested for the benefit of all pilgrims to take the least time possible for Darshan and to take Darshan only once on 31st January.</li>
						<li style="text-align: justify">After collecting a single token with a number on it, each Pilgrim will be free to move about until the number on his/her token is announced and displayed on the signboards.</li>
						<li style="text-align: justify">THE PILGRIMS SHOULD JOIN THE QUEUE WHEN THEIR NUMBER IS DISPLAYED.</li>
						<li style="text-align: justify">Please be alert because if your number has passed through the Darshan line and the next higher number has also passed, you will miss your turn and will require a new token.</li>
					</ol>
				</v-flex>
			</v-layout>
		</v-container>
  </v-app>
  </div>
</template>
<script>
  import { reduce } from 'lodash'
  export default {
    methods: {
      displayDetails (id) {
        this.$router.push({name: 'detail', params: { id: id }})
      },
      getToken () {
        if (navigator.onLine) {
          this.saveTokenToCache()
          return reduce(this.$root.Trust, (Token, firebaseEntry) => {
            Token[firebaseEntry['.key']] = {
              url: firebaseEntry['url']
            }
            return Token
          }, {})
        } else {
          var token = window.JSON.parse(localStorage.getItem('Token'))
          return token
        }
      },
      saveTokenToCache () {
        this.$root.$firebaseRefs.Trust.once('value', (snapchot) => {
          let cachedToken = {}
          snapchot.forEach((catSnapchot) => {
            cachedToken[catSnapchot.key] = catSnapchot.val()
          })
          window.localStorage.setItem('Token', JSON.stringify(cachedToken))
        })
      }
    },
    mounted () {
      this.saveTokenToCache()
    }
  }
</script>

<style scoped>
  .add-picture-button {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 998;
  }
  .image-card {
    position: relative;
    margin-bottom: 8px;
  }
  .image-card__picture > img {
    width:60%;
  }
  .image-card__comment {
    position: absolute;
    bottom: 0;
    height: 52px;
    padding: 16px;
    text-align: right;
    background: rgba(0, 0, 0, 0.5);
  }
  .image-card__comment > span {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }
</style>
<style>

p{
  color: black;
  font-weight: bold;
}

li {
  color: black;
  font-weight: bold;
}
  #darshan {
	background-image: linear-gradient(rgba(255, 246, 118, 0.8),rgba(255, 246, 118, 0.8)), url("/static/doc-images/lists/darshan.jpg");
	padding: 16px;
	background-size: cover;
  }
  
  .application--light {
    background: transparent;
    color: rgba(0,0,0,0.87);
}
</style>


// WEBPACK FOOTER //
// token.vue?ce6d772a